export const ucFirst = (sentence) => {
    return sentence.charAt(0).toUpperCase() + sentence.substring(1)
}